import ArrowSwapHorizontal from "@assets/icons/arrowSwapHorizontal"
import { cn } from "src/utils/common.helper"
import { useSelector } from "react-redux"
import formatDateFromISOString from "src/utils/formatDate"
import AppointmentsEmpty from "@components/Common/EmptyAppointments"
import ArrowUpIcon from "@assets/icons/arrowUp"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

const TimeAppointments = ({ rootClassName }) => {
  const [sortOrder, setSortOrder] = useState("asc") // "asc" or "desc"
  const navigate = useNavigate()
  const { getCalendarBookingResponse } = useSelector((state) => {
    return state.booking
  })

  const currentBookings = getCalendarBookingResponse?.currentBooking

  // Helper function to toggle sort order
  const toggleSortOrder = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc")
  }

  // Helper function to get background color based on appointment type
  const getAppointmentBgColor = (type) => {
    switch (type?.toLowerCase()) {
      case "followup":
        return "bg-[#ECFAEF]"
      case "consultation":
        return "bg-[#FFFBD9]"
      case "prescription":
        return "bg-[#FBEEFF]"
      default:
        return "bg-[#ECFAEF]" // Default color
    }
  }

  // Helper function to format time with 2 digits
  const formatTimeDigits = (timeValue) => {
    return String(timeValue).padStart(2, "0")
  }

  // Sort appointments based on current sort order
  const sortedBookings = currentBookings?.slice().sort((a, b) => {
    const startDateA = new Date(a.startDateTime)
    const startDateB = new Date(b.startDateTime)
    return sortOrder === "asc"
      ? startDateA - startDateB
      : startDateB - startDateA
  })

  // Handle appointment click to navigate to details page
  const handleAppointmentClick = (appointment) => {
    navigate("/manage-appointment/appointment-details", {
      state: { appointment },
    })
  }

  return (
    <div
      className={cn(
        "min-w-[200px] bg-white m-1 rounded-2xl p-6 max-w-96 gap-4 flex flex-col overflow-visible max-h-max overflow-y-hidden border border-[#C4E2FF] md:border-0",
        rootClassName
      )}
    >
      <div className="text-[--primary-blue] font-bold text-sm flex justify-between gap-4 w-full tracking-widest">
        TIME APPOINTMENTS
        <button
          onClick={toggleSortOrder}
          className="flex items-center cursor-pointer"
          aria-label={`Sort ${sortOrder === "asc" ? "descending" : "ascending"}`}
        >
          <ArrowSwapHorizontal
            className={sortOrder === "desc" ? "transform rotate-180" : ""}
          />
        </button>
      </div>
      <div className="gap-4 flex flex-col overflow-y-scroll theme-scrollbar">
        {sortedBookings?.map((item) => (
          <div
            className="gap-4 flex items-center cursor-pointer hover:opacity-90 transition-opacity"
            key={item.id || `${item.startDateTime}-${item.firstName}`}
            onClick={() => handleAppointmentClick(item)}
          >
            <div>
              <div className="text-[--senary-black] text-sm font-bold">
                {formatTimeDigits(
                  formatDateFromISOString(item.startDateTime).hours
                )}
                :{" "}
                {formatTimeDigits(
                  formatDateFromISOString(item.startDateTime).minutes
                )}
              </div>
              <div className="text-[--tertiary-gray-light] text-sm">
                {formatTimeDigits(
                  formatDateFromISOString(item.endDateTime).hours
                )}
                :{" "}
                {formatTimeDigits(
                  formatDateFromISOString(item.endDateTime).minutes
                )}
              </div>
            </div>
            <div
              className={`${getAppointmentBgColor(item.type)} rounded-2xl py-2 px-4 grow`}
            >
              <div className="text-[#475467] text-base font-semibold flex justify-between">
                {item.firstName}
                <ArrowUpIcon className="text-[--primary-blue] rotate-180" />
              </div>
              <div className="text-[#475467]">type- {item.type}</div>
              <div className="text-[#475467]">contact- {item.contact}</div>
            </div>
          </div>
        ))}
      </div>
      {!sortedBookings || sortedBookings.length === 0 ? (
        <AppointmentsEmpty />
      ) : null}
    </div>
  )
}

export default TimeAppointments
